import React from 'react';
import { CaseSelectors } from './CaseSelectors';
import { CaseComponents } from '../../../CaseComponents/CaseComponents';
import type { ProductProps } from 'tsconfig/types';

interface Props {
  targetRef: React.RefObject<HTMLDivElement>;
  activeBottomCase: number;
  products: ProductProps[];
  upsellProduct: ProductProps | null;
  upsellSelected: boolean;
  referencedSkus: Array<{
    itemId: string;
    quantity: number;
    expandedItem: ProductProps;
  }>;
  handleCaseClick: (index: number) => void;
  handleUpsellClick: () => void;
  isMobileView: boolean;
}

export const ReferencedCaseTabPanel = ({
  targetRef,
  activeBottomCase,
  products,
  upsellProduct,
  upsellSelected,
  referencedSkus,
  handleCaseClick,
  handleUpsellClick,
  isMobileView,
}: Props) => (
  <div id="panel-case-selector" ref={targetRef} data-testid="reference-casetab-panel">
    <CaseSelectors
      className="mcs-main-row mcs-selector-wrap"
      from="target-panel"
      view="simple"
      activeBottomCase={activeBottomCase}
      products={products}
      upsellProduct={upsellProduct}
      upsellSelected={upsellSelected}
      handleCaseClick={handleCaseClick}
      handleUpsellClick={handleUpsellClick}
    />
    {referencedSkus && (
      <CaseComponents
        referencedSkus={referencedSkus}
        upsellProduct={upsellProduct}
        view={isMobileView ? 'carousel' : ''}
      />
    )}
  </div>
);
